import {
  ILvl1Item,
  ILvl2Item,
  ILvl3Item,
  ILvl4Item,
} from 'pages/NewProject/components/ProjectSkillsStandards/interfaces'

export type { ILvl1Item, ILvl2Item, ILvl3Item, ILvl4Item }

export type TreeItem = ILvl1Item | ILvl2Item | ILvl3Item | ILvl4Item

export type BrowseTab = 'standards' | 'skills'

export interface NavigationPathItem {
  id: string
  name: string
  level: 1 | 2 | 3
  color?: string
}

export interface BrowseTreeData {
  subjects: ILvl1Item[]
  axes: ILvl1Item[]
}

export const isLvl4Item = (item: unknown): item is ILvl4Item => {
  return (
    typeof item === 'object' &&
    item !== null &&
    'id' in item &&
    typeof (item as ILvl4Item).id === 'string' &&
    'name' in item &&
    typeof (item as ILvl4Item).name === 'string'
  )
}

export const hasChildren = (
  item: TreeItem,
): item is ILvl1Item | ILvl2Item | ILvl3Item => {
  return 'children' in item && Array.isArray(item.children)
}

export const getChildren = (item: TreeItem): TreeItem[] => {
  if (!item || !('children' in item)) return []
  return (item.children as TreeItem[]) ?? []
}
